import Api from '@/apis/productContentApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getSettings () {
    return Api()
      .get('/settings')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Content.Messages.GetSettingsErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getSupport () {
    return Api()
      .get('/support')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Content.Messages.GetSupportErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
